import DictionaryIcon_Trans from "../../../assets/UI/DictionaryIcon_Trans.png";
import SearchBarDictionary from "../DictionaryComponents/SearchBar_Dictionary/SearchBar_Dictionary";
import "../Dictionary.css";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";

//Word Grids
import WordGridLarge from "../DictionaryComponents/WordGrid/WordGridLarge";

//Arrays
import { FormalRelations } from "../../../SubjectData/BasicWords/Relationships";
import { RomanticRelationships } from "../../../SubjectData/BasicWords/Relationships";
import { SocialRelations } from "../../../SubjectData/BasicWords/Relationships";
import { Friendship } from "../../../SubjectData/BasicWords/Relationships";

import Popup from "../../../Components/Popup/Dictionary_Popup";
import {useState} from "react";

export default function RelationshipsDictionary(){

    const [openPopup, setOpenPopup] = useState(null);

    const allData = [
                        ...Friendship, 
                        ...RomanticRelationships,
                        ...SocialRelations,
                        ...FormalRelations,
                    
                    ];
    
        return(
       
               <div>
                   <HeaderNavNTM GoBack_to="/RelationshipsNav"/>
                   <div className="blue-header-dict">
                       
                       <img className="DictionaryImage" src={DictionaryIcon_Trans} alt="Dictionary"></img>
                      
                         <SearchBarDictionary data={allData} onSelectItem={setOpenPopup} />
                       
                   </div>
       
                   <div>
                       
                       <WordGridLarge data={Friendship} title="Friendship" onSelectItem={setOpenPopup} />
                       <WordGridLarge data={RomanticRelationships} title="Romantic Relationships" onSelectItem={setOpenPopup} />  
                       <WordGridLarge data={SocialRelations} title="Social Relationships" onSelectItem={setOpenPopup} />
                       <WordGridLarge data={FormalRelations} title="Formal Relationships" onSelectItem={setOpenPopup} />  
                                              
                       <Popup item={openPopup} onClose={() => setOpenPopup(null)} />
                  
                   </div>
                   
               </div>
       
           );
       
       }
       
    
    
    //Resources
        //Making a search bar
            //https://builtin.com/articles/react-search-bar